<lib-form-field-container
    #anchor
    [kind]="FormContainerKind.Date"
    [matMenu]="timeMenu">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>

    <ng-container prefixIcon>
        <lib-icon-button
            [kind]="ButtonKind.FormField"
            [size]="ButtonSize.Large"
            [disabled]="isDisabled"
            [icon]="Icon.Common.Time"
            (clicked)="OpenMenu(anchor)"></lib-icon-button>
    </ng-container>

    <ng-content bottomMenu select="[bottomMenu]"></ng-content>

    <ng-container readOnly>
        <div
            class="wrapper-content"
            #providedReadOnly>
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            @if (formControl.value) {
                {{ formControl.value.Render() }}
            } @else {
                <ng-container
                    i18n="@@CommonNotSpecifiedLabel">
                    Not specified
                </ng-container>
            }
        </div>
    </ng-container>

    <input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                [attr.aria-label]="ariaLabel || null"
                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [formControl]="viewControl"
        (focusout)="StopEditing()"
        [attr.data-sb-qa]="qaTag" />

    <mat-menu
        #timeMenu="matMenu"
        yPosition="below"
        class="time-menu"
        backdropClass="matMenuCustomBackdrop">
        <div [ngStyle]="{ width: anchor.containerBox?.nativeElement?.clientWidth + 'px' }">
            <mbsc-datepicker
                [(value)]="time"
                theme="ios"
                themeVariant="light"
                [circular]="circularityArray"
                display="inline"
                [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
                [minTime]="minimumHour.toString() + ':00'"
                [maxTime]="maximumHour.toString() + ':59'"
                [stepMinute]="minuteStep"
                [controls]="['time']"
                returnFormat="jsdate"
                [timeFormat]="timeFormat"
                [amText]="amDesignator"
                [pmText]="pmDesignator"
                (click)="$event.stopPropagation()"
                (mousedown)="TimePickerUsed()"
                (touchstart)="TimePickerUsed()"
                (wheel)="TimePickerUsed()"></mbsc-datepicker>
        </div>
    </mat-menu>
</lib-form-field-container>
